import { Modal, Button } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { useState } from 'react';

function Logout({ show, onClose }) {
  const handleYes = () => onClose(true);
  const handleNo = () => onClose(false);

  return (
    <Modal show={show} onHide={() => onClose(false)}>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "black" }}>Logout</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ color: "#1c1c1c" }}>
        Are you sure you want to logout?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleNo}>
          No
        </Button>
        <Button variant="primary" onClick={handleYes}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default Logout;
